(() => {
  const update = (hero, index) => {
    const words = [...hero.querySelectorAll('.slideshow-word')];
    if (!Number.isInteger(index) || index < 0 || index >= words.length) return;
    words.forEach((word, position) => word.setAttribute('aria-current', String(position === index)));
    const counter = hero.querySelector('[data-dope-hero-current]');
    if (counter) counter.textContent = String(index + 1).padStart(2, '0');
  };
  document.addEventListener('slider:change', event => {
    const hero = event.target.closest('[data-dope-hero]');
    if (hero) update(hero, event.detail?.currentPage);
  });
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-dope-hero]').forEach(hero => {
      update(hero, Number(hero.querySelector('slideshow-element')?.getAttribute('selected-index') || 0));
    });
  });
})();
